var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1089 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(1089 489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10410.028-12993.17h-16.067a.974.974,0,0,1-.974-.974v-4.953h-.595a1.394,1.394,0,0,1-1.393-1.392v-7.236a1.4,1.4,0,0,1,1.393-1.393h.595v-7.909a.974.974,0,0,1,.974-.974h11.768a.672.672,0,0,1,.1.012h.008a.136.136,0,0,0,.026.01.507.507,0,0,1,.095.04l.01.006.022.014a.449.449,0,0,1,.1.081h0l0,0,4.785,5.469a.484.484,0,0,1,.117.313.222.222,0,0,0,0,.025c0,.012,0,.021,0,.03v2.878h.595a1.394,1.394,0,0,1,1.392,1.393v7.236a1.393,1.393,0,0,1-1.392,1.392H10411v4.953A.974.974,0,0,1,10410.028-12993.17Zm-16.067-5.927v4.688h16.067v-4.688Zm10.719-8.6v7.286h1.5v-3.343h2.369v-1.212h-2.369v-1.509h2.535v-1.223Zm-7.449,1.382v5.891h1.646l0-5.891h1.983v-1.382h-5.587v1.382Zm4.715-1.382v7.27h1.649v-7.27Zm-7.984-9.327v7.909h16.067v-2.44h-4.3a.486.486,0,0,1-.486-.486v-4.982Z",
    transform: "translate(-9302 13507)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTif);
export default __webpack_public_path__ + "static/media/tif.3943b052d1e69b58e0acbe5de341b493.svg";
export { ForwardRef as ReactComponent };